import React from 'react';
import { margin } from '~/../config.json';
import { translate } from '~/utils';
import { ChartLine, ChartLabel } from './ChartComponents';

export default function YAxis({ width, barHeight, yScale }) {
  const ticks = [0, 10, 20, 30, 40, 50, 60, 70, 80, 85];

  return (
    <g transform={translate(0, 0)}>
      <g transform={translate(width / 2 + margin.center / 2, -10)}>
        <ChartLabel fontWeight="bold" textAnchor="middle">
          Alter in Jahren
        </ChartLabel>
      </g>
      {ticks.map((tick) => (
        <g transform={translate(0, yScale(tick) + barHeight / 2)}>
          <g>
            <ChartLine dashed x1={0} x2={width / 2} y1={0} y2={0} />
          </g>
          <g transform={translate(width / 2 + margin.center / 2, 0)}>
            <ChartLabel y={4} textAnchor="middle">
              {tick === 85 ? '> 85' : tick}
            </ChartLabel>
          </g>
          <g transform={translate(width / 2 + margin.center, 0)}>
            <ChartLine dashed x1={0} x2={width / 2} y1={0} y2={0} />
          </g>
        </g>
      ))}
    </g>
  );
}
